(ns client-portal.client.voice-insights.items.comparison.views
  (:require [client-portal.client.voice-insights.items.comparison.data :as comparison.d]
            [client-portal.client.voice-insights.items.data]
            [shared.core.components.recharts.tooltip :as recharts.tooltip]
            [shared.core.components.components :as c]
            [shared.core.amelia-light.components.components :as alc]
            [client-portal.client.voice-insights.empty-state :as empty-state]
            [client-portal.client.vi.components.tag :as tag]
            [shared.core.components.recharts-components :as recharts.c]
            [client-portal.client.voice-insights.tag-data :as tag.d]
            [client-portal.client.voice-insights.sessions.data :as sessions.d]
            [shared.core.reactive :as re]
            [shared.core.router :as router]
            [shared.core.style :as style]
            [shared.core.util :as util]))

(def metric-category-flex "0 0 165px")

(def item-index->color
  {0 (style/alc-color "chart/green")
   1 (style/alc-color "Chart/orchid")
   2 (style/alc-color "Chart/tech_blue")})

(defn remove-item-x [_]
  (let [items- (re/subscribe [:vi-items/all-comparison-items-])]
    (fn [{:keys [index style]}]
      (let [item (get @items- index)]
        (when (and index (some-> (:data item) (util/loading?) (not)))
          [alc/up-ghost-button {:icon-type :CrossIcon
                                :on-click #(re/dispatch [:vi-items/remove-comparison-item index])
                                :style (merge {:position :absolute
                                               :top 10
                                               :right 10}
                                              style)}])))))

(defn floating-item-dropdown [_]
  (let [all-items- (re/subscribe [:vi-items/all-comparison-items-])
        items-list- (re/subscribe [:vi-items/list-by-current-concept-id-])]
    (fn [{:keys [index open?*]}]
      (let [other-item-labels (->> @all-items-
                                   (remove (fn [[idx _]] (= idx index)))
                                   (map (fn [[_ {:keys [label]}]] label))
                                   (filter identity)
                                   (into #{}))]
        [alc/up-searchable-list
         {:search-placeholder "Search"
          :no-results-message "No items found."
          :options (->> @items-list-
                        (mapv (fn [{:keys [item]}]
                                {:text item :value item}))
                        (remove (fn [{:keys [value]}]
                                  (contains? other-item-labels value))))
          :on-select (fn [value]
                       (re/dispatch [:form/change (conj comparison.d/items-path index) :label value])
                       (re/dispatch [:vi-items/set-comparison-items-query-param])
                       (reset! open?* false))}]))))

(defn item-comparison-block [_]
  (let [open?* (re/ratom false)
        hover?* (re/ratom false)]
    (fn [{:keys [index]}]
      (let [item @(re/subscribe [:vi-items/comparison-item-by-index- index])
            container-height 162
            table-border (str "1px solid " (style/alc-color "Border/divider_secondary"))]
        (if-let [item-label (:label item)]
          (let [_ @(re/subscribe [:vi-items/comparison-item-data-by-index- index]) ;; This will trigger data loads
                item-color (get item-index->color index)
                item-data (:data item)
                item-data-loading? (or (not item-data) (util/loading? item-data))]
            [:div {:style {:border table-border
                           :border-radius 12
                           :flex 1
                           :overflow :hidden
                           :position :relative
                           :height container-height}}
             [remove-item-x {:index index}]
             [:div {:style {:background (str "radial-gradient(57.69% 21.52% at 50% 0%, "
                                             (util/hex->rgba item-color 0.15)
                                             " 0%, "
                                             (util/hex->rgba item-color 0)
                                             " 100%), "
                                             (style/alc-color "Background/tertiary"))
                            :display :flex
                            :flex-direction :column
                            :align-items :center
                            :justify-content :center
                            :gap 16
                            :padding "0 12px"
                            :height "100%"
                            :width "100%"}}
              [:div {:style {:display :flex
                             :align-items :center
                             :gap 12}}
               [:div {:style {:background-color item-color
                              :border-radius 3
                              :height 12
                              :width 12}}]
               [:span {:style {:color (style/alc-color "Text/primary")
                               :font-size 16
                               :font-weight 500
                               :line-height 1.38
                               :text-align :center}}
                item-label]]
              [:div {:style {:display :flex
                             :flex-direction :column
                             :align-items :center
                             :gap 6}}
               (if item-data-loading?
                 [c/loader-rectangle {:height (* 36 1.11)
                                      :width 56}]
                 [:span {:style {:color (style/alc-color "Text/primary")
                                 :font-size 36
                                 :font-weight 700
                                 :line-height 1.11}}
                  (or (some->> item-data
                               (map :count)
                               (apply +)
                               (util/readable-number))
                      "-")])
               (if item-data-loading?
                 [c/loader-rectangle {:height (* 14 1.43)
                                      :width 68
                                      :style {:margin-top 6}}]
                 [:span {:style {:color (style/alc-color "")
                                 :font-size 14
                                 :font-weight 400
                                 :line-height 1.43}}
                  "Total Tags"])]]])
          [:div {:style {:flex 1
                         :position :relative}}
           [alc/up-popover
            {:open @open?*
             :on-open-change #(reset! open?* %)
             :side "bottom"
             :align "center"
             :class-name "p-0"
             :trigger [:div {:on-mouse-over #(reset! hover?* true)
                             :on-mouse-out #(reset! hover?* false)
                             :style (cond-> {:border table-border
                                             :border-radius 8
                                             :cursor :pointer
                                             :display :flex
                                             :flex-direction :column
                                             :align-items :center
                                             :justify-content :center
                                             :gap 10
                                             :padding "6px 12px"
                                             :transition "0.2s"
                                             :height container-height}
                                            @open?*
                                            (assoc :background-color (style/alc-color "Background/active_c"))
                                            (and (not @open?*) @hover?*)
                                            (assoc :background-color (style/alc-color "Background/hover")))}
                       [alc/up-secondary-icon {:icon-type :AddIcon
                                               :height 24
                                               :width 24}]
                       [:span {:style {:font-size 14
                                       :font-weight 400
                                       :line-height 1.43
                                       :color (style/alc-color "Text/secondary")
                                       :user-select :none}}
                        "Add item to compare"]]
             :content [floating-item-dropdown {:index index
                                               :open?* open?*}]}]])))))

(defn item-comparison-tab [{:keys [label index item style show-remove-item?]}]
  (let [item-color (get item-index->color index)]
    [:div {:style (merge {:color (style/alc-color "Text/secondary")
                          :font-size 12
                          :font-weight 400
                          :line-height 1.33
                          :text-align :center
                          :flex 1
                          :display :flex
                          :align-items :center
                          :justify-content :center
                          :padding 6
                          :position :relative}
                         (when item
                           {:background (str "radial-gradient(268.08% 100% at 50% 0%, "
                                             (util/hex->rgba item-color 0.15)
                                             " 0%, "
                                             (util/hex->rgba item-color 0)
                                             " 100%), "
                                             (style/alc-color "Background/tertiary"))
                            :color (style/alc-color "Text/primary")
                            :font-weight 500})
                         style)}
     (when show-remove-item?
       [remove-item-x {:index index
                       :style {:background-color :none
                               :top 5
                               :right 5}}])
     label]))

(defn add-item-for-comparison-tab [_]
  (let [open?* (re/ratom false)
        hover?* (re/ratom false)]
    (fn [{:keys [index]}]
      [alc/up-popover
       {:open @open?*
        :on-open-change #(reset! open?* %)
        :side "bottom"
        :align "start"
        :class-name "p-0"
        :trigger [:div {:on-mouse-over #(reset! hover?* true)
                        :on-mouse-out #(reset! hover?* false)
                        :style (cond-> {:cursor :pointer
                                        :flex 1
                                        :padding 6
                                        :position :relative}
                                       @open?*
                                       (assoc :background-color (style/alc-color "Background/active_c"))
                                       (and (not @open?*) @hover?*)
                                       (assoc :background-color (style/alc-color "Background/hover")))}
                  [:div {:style {:height "100%"
                                 :width "100%"}}
                   [:div {:style {:color (style/alc-color "Text/secondary")
                                  :font-size 12
                                  :font-weight 400
                                  :line-height 1.5
                                  :display :flex
                                  :align-items :center
                                  :justify-content :center
                                  :height "100%"}}
                    [c/material-icon {:icon-type :add
                                      :style {:font-size 18
                                              :color (style/alc-color "Text/secondary")
                                              :user-select :none}}]
                    [:span {:style {:color (style/alc-color "Text/secondary")
                                    :font-size 12
                                    :line-height 1.5
                                    :font-weight 400
                                    :user-select :none}}
                     "Add Item"]]]]
        :content [floating-item-dropdown {:index index
                                          :open?* open?*}]}])))

(defn item-comparison-tabs []
  (let [items @(re/subscribe [:vi-items/all-comparison-items-])
        show-remove-item? (> (count items) 1)]
    [:div {:style {:background-color (style/alc-color "Background/card_hex_secondary")
                   :position :sticky
                   :top (or (some-> (js/document.getElementById "item-analytics-header")
                                    (.getBoundingClientRect)
                                    (.-height))
                            0)
                   :left 0
                   :z-index (style/z :medium)}}
     [:div {:style {:display :flex
                    :height 50
                    :width "100%"}}
      (into [:div {:style {:display :flex
                           :width "100%"}}
             [item-comparison-tab {:label nil
                                   :style {:flex metric-category-flex}}]]
            (mapv (fn [index]
                    (if-let [item (get items index)]
                      [item-comparison-tab {:label (:label item)
                                            :index index
                                            :item item
                                            :show-remove-item? show-remove-item?}]
                      [add-item-for-comparison-tab {:index index}]))
                  (range 3)))]]))

(defn comparison-section-header-label-container [{:keys [label style]}]
  [:div {:style (merge {:flex 1
                        :display :flex
                        :justify-content :center}
                       style)}
   [:span {:style {:color (style/alc-color "Text/secondary")
                   :font-size 14
                   :font-weight 400
                   :line-height 1.43}}
    label]])

(defn comparison-section-header [_]
  (let [items- (re/subscribe [:vi-items/all-comparison-items-])]
    (fn [{:keys [icon-type label accept-decline? first?]}]
      (let [items @items-
            table-border (str "1px solid " (style/alc-color "Border/divider_secondary"))]
        (into [:div {:style (cond-> {:background-color (style/alc-color "Background/secondary")
                                     :border-bottom table-border
                                     :display :flex
                                     :align-items :center
                                     :padding "6px 0"
                                     :height 36}
                                    first?
                                    (assoc :border-top-left-radius 12
                                           :border-top-right-radius 12))}
               [:div {:style {:flex metric-category-flex
                              :display :flex
                              :align-items :center
                              :gap 10
                              :padding-left 16}}
                [c/material-icon {:icon-type icon-type
                                  :style {:color (style/alc-color "Text/secondary")
                                          :font-size 14}}]
                [:span {:style {:color (style/alc-color "Text/secondary")
                                :font-size 14
                                :font-weight 400
                                :line-height 1.43}}
                 label]]]
              (mapv (fn [index]
                      (let [label? (get items index)]
                        (if accept-decline?
                          [:div {:style {:flex 1
                                         :display :flex
                                         :justify-content :center
                                         :padding "0 16px"}}
                           [comparison-section-header-label-container {:label (when label? "Accept")}]
                           [comparison-section-header-label-container {:label (when label? "Decline")}]]
                          [comparison-section-header-label-container {:label (when label? "Count")
                                                                      :style {:padding "0 16px"}}])))
                    (range 3)))))))

(defn metric-row-tag-value [_]
  (let [sessions-query-params @(re/subscribe [:sessions/relevant-query-params-])]
    (fn [{:keys [value total filter-tag children] :as args}]
      (let [v (some->> (when (pos? total) total) (/ value) (* 100))
            rounded-v (some-> v (js/Math.floor))
            percent-display (when v
                              (cond
                                (= value 0)
                                "0%"

                                (< rounded-v 1)
                                "<1%"

                                :else
                                (str (util/to-precision v :precision 1) "%")))
            support-double-click? (and (not-empty children) filter-tag)]
        ^{:key (pr-str args)}
        [alc/tooltip
         {:target-content [:div {:on-double-click (when support-double-click?
                                                    (fn [e]
                                                      (router/open-route-based-on-event
                                                        e
                                                        [:vi/sessions nil (assoc sessions-query-params
                                                                            :svm "utterances"
                                                                            :fd (sessions.d/filters->query-param
                                                                                  [{:by "tags"
                                                                                    :condition "include"
                                                                                    :join "or"
                                                                                    :value [filter-tag]
                                                                                    :children children}]))])))
                                 :style {:flex 1
                                         :display :flex
                                         :align-items :center
                                         :justify-content :center
                                         :user-select :none
                                         :height "100%"
                                         :width "100%"}}
                           [:span {:style {:color (style/alc-color "Text/primary")
                                           :font-size 14
                                           :font-weight 500
                                           :line-height 1.2
                                           :text-align :right
                                           :flex 1
                                           :margin-right 3}}
                            (or (some-> value (util/readable-number)) "N/A")]
                           [:span {:style {:flex 1
                                           :display :flex
                                           :align-items :center
                                           :margin-left 3}}
                            (when v
                              [:span {:style {:color (style/alc-color "Text/secondary")
                                              :font-size 12
                                              :font-weight 500
                                              :line-height 1.2
                                              :text-align :left}}
                               (str "(" percent-display ")")])]]
          :tooltip-content [:div {}
                            (when percent-display
                              [:div {:style {:text-align :center
                                             :width "100%"}}
                               (str percent-display
                                    " of "
                                    (util/readable-number total)
                                    " "
                                    (util/pluralize "session" total))])
                            (when (and percent-display support-double-click?)
                              [recharts.tooltip/footer-separator {}])
                            (when support-double-click?
                              [recharts.tooltip/double-click-tooltip-display {}])]
          :style {:cursor :pointer
                  :height "100%"
                  :width "100%"}}]))))

(defn metric-row [_]
  (let [items- (re/subscribe [:vi-items/all-comparison-items-])
        convo-count- (re/subscribe [:vi-items/conversations-count-by-current-concept-id-])]
    (fn [{:keys [label tag-name accept-and-decline-outcomes? tag-value odd? last?]}]
      (let [convo-count (util/when-not-loading @convo-count-)
            loading-item-indexes (or (some->> @items-
                                              (filter (fn [[_ {:keys [data]}]]
                                                        (or (not data) (util/loading? data))))
                                              (map first)
                                              (into #{}))
                                     #{})
            sorted-item-data (some->> @items-
                                      (sort-by first)
                                      (mapv (fn [[index {:keys [data]}]]
                                              (mapv #(assoc % :index index) (util/when-not-loading data))))
                                      (filterv #(and % (util/when-not-loading %)))
                                      (flatten)
                                      (filterv #(= (:tag-name %) tag-name)))
            sorted-item-data-by-index (group-by :index sorted-item-data)
            tag-desc (tag.d/tag->description {:name tag-name :value tag-value})
            table-border (str "1px solid " (style/alc-color "Border/divider_secondary"))]
        (into [:div {:style (cond-> {:border-bottom table-border
                                     :display :flex
                                     :height 58
                                     :width "100%"}
                                    last?
                                    (assoc :border-bottom-left-radius 12
                                           :border-bottom-right-radius 12
                                           :border-right table-border
                                           :border-bottom table-border
                                           :border-left table-border))}
               [alc/tooltip
                {:style (cond-> {:flex metric-category-flex
                                 :user-select :none}
                                tag-desc
                                (assoc :cursor :help))
                 :target-content [:div {:style (cond-> {:border-right table-border
                                                        :color (style/alc-color "Text/primary")
                                                        :font-size 12
                                                        :font-weight 400
                                                        :text-align :right
                                                        :display :flex
                                                        :align-items :center
                                                        :justify-content :flex-end
                                                        :padding "12px 8px 12px 16px"
                                                        :height "100%"}
                                                       (not last?)
                                                       (assoc :border-left table-border))}
                                  label]
                 :tooltip-content tag-desc}]]
              (mapv (fn [index]
                      (if-let [item (get @items- index)]
                        (let [get-tag-count (fn [tv child-tag]
                                              (or (some->> (get sorted-item-data-by-index index)
                                                           (filterv #(and (= tv (:tag-value %))
                                                                          (or (not child-tag)
                                                                              (some (fn [c]
                                                                                      (and (= (:name c)
                                                                                              (:name child-tag))
                                                                                           (= (:value c)
                                                                                              (:value child-tag))))
                                                                                    (:children %)))))
                                                           (map :count)
                                                           (apply +))
                                                  0))
                              common-row-tag-value-args {:filter-tag {:name tag-name
                                                                      :value tag-value}
                                                         :children [{:by "menu-item"
                                                                     :condition "include"
                                                                     :join "or"
                                                                     :value [(:label item)]}]
                                                         :value (get-tag-count tag-value nil)
                                                         :total convo-count}]
                          [:div {:style {:border-right (when (or (not last?) (< index 2))
                                                         table-border)
                                         :flex 1
                                         :display :flex
                                         :align-items :center
                                         :justify-content :center
                                         :padding "12px 16px"
                                         :height "100%"}}
                           (cond
                             (contains? loading-item-indexes index)
                             (if accept-and-decline-outcomes?
                               [:div {:style {:display :flex
                                              :align-items :center
                                              :justify-content :space-around
                                              :height "100%"
                                              :width "100%"}}
                                [c/loader-rectangle {:height 14
                                                     :width 42}]
                                [c/loader-rectangle {:height 14
                                                     :width 42}]]
                               [c/loader-rectangle {:height 14
                                                    :width 42}])

                             accept-and-decline-outcomes?
                             [:div {:style {:display :flex
                                            :align-items :center
                                            :justify-content :space-around
                                            :height "100%"
                                            :width "100%"}}
                              [metric-row-tag-value (assoc common-row-tag-value-args
                                                      :value (get-tag-count tag-value {:name "outcome"
                                                                                       :value "accept"})
                                                      :children (conj (:children common-row-tag-value-args)
                                                                      {:by "outcome"
                                                                       :condition "include"
                                                                       :join "or"
                                                                       :value ["accept"]}))]
                              [metric-row-tag-value (assoc common-row-tag-value-args
                                                      :value (get-tag-count tag-value {:name "outcome"
                                                                                       :value "decline"})
                                                      :children (conj (:children common-row-tag-value-args)
                                                                      {:by "outcome"
                                                                       :condition "include"
                                                                       :join "or"
                                                                       :value ["decline"]}))]]

                             :else
                             [metric-row-tag-value common-row-tag-value-args])])
                        [:div {:style (cond-> {:flex 1
                                               :padding "12px 16px"
                                               :height "100%"}
                                              (< index 2)
                                              (assoc :border-right table-border))}]))
                    (range 3)))))))

(defn crew-upsell-comparison []
  [:div
   [comparison-section-header {:icon-type :rocket-launch
                               :label "Upsell Prompt"
                               :first? true}]
   [metric-row {:label "Add-On"
                :tag-name "crew-upsell"
                :tag-value "add-on"}]
   [metric-row {:label "Combo"
                :tag-name "crew-upsell"
                :tag-value "combo"
                :odd? true}]
   [metric-row {:label "Size"
                :tag-name "crew-upsell"
                :tag-value "size"}]])

(defn customer-upsell-comparison []
  (let [shared-tag-config {:tag-name "crew-upsell"
                           :accept-and-decline-outcomes? true}]
    [:div
     [comparison-section-header {:icon-type :person
                                 :label "Upsell Outcome"
                                 :accept-decline? true}]
     [metric-row (merge {:label "Add-On"
                         :tag-value "add-on"}
                        shared-tag-config)]
     [metric-row (merge {:label "Combo"
                         :tag-value "combo"}
                        shared-tag-config)]
     [metric-row (merge {:label "Size"
                         :tag-value "size"}
                        shared-tag-config)]]))

(defn user-questions-comparison []
  (let [question-types (some->> @(re/subscribe [:vi-items/all-comparison-items-])
                                (mapv (fn [[index {:keys [data]}]]
                                        (mapv #(assoc % :index index) (util/when-not-loading data))))
                                (filterv #(and % (util/when-not-loading %)))
                                (flatten)
                                (filterv #(= (:tag-name %) "question"))
                                (mapv :tag-value)
                                (distinct)
                                (sort))]
    (when (not-empty question-types)
      (some->> (when (not-empty question-types) question-types)
               (mapv (fn [qt]
                       [metric-row {:label (tag/tag->display-name {:value qt})
                                    :tag-name "question"
                                    :tag-value qt}]))
               (into [:div
                      [comparison-section-header {:icon-type :live-help
                                                  :label "User Questions"}]])))))

(defn unavailable-comparison []
  (let [unavailable-data (->> @(re/subscribe [:vi-items/all-comparison-items-])
                              (mapcat (fn [[_ {:keys [data]}]]
                                        (util/when-not-loading data)))
                              (filter #(= (:tag-name %) "unavailable")))]
    (when (not-empty unavailable-data)
      (let [tag-vals (->> unavailable-data
                          (map :tag-value)
                          (distinct)
                          (sort-by name))]
        (into [:div
               [comparison-section-header {:icon-type :report
                                           :label "Unavailable"}]]
              (map-indexed (fn [idx tag-value]
                             [metric-row {:label (tag/tag->display-name {:value tag-value})
                                          :tag-name "unavailable"
                                          :tag-value tag-value
                                          :odd? (odd? idx)
                                          :last? (>= idx (dec (count tag-vals)))}])
                           tag-vals))))))

(defn comparison-view []
  (let [sessions-query-params @(re/subscribe [:sessions/relevant-query-params-])
        all-items @(re/subscribe [:vi-items/all-comparison-items-])
        items? (some #(not-empty (:label (second %))) all-items)
        items-data? (some #(some-> %
                                   (second)
                                   :data
                                   (util/when-not-loading)
                                   (not-empty))
                          all-items)
        convo-count (util/when-not-loading @(re/subscribe [:vi-items/conversations-count-by-current-concept-id-]))]
    [:div {:style {:flex 1
                   :display :flex
                   :flex-direction :column
                   :gap 16}}
     (into [:div {:style {:display :flex
                          :gap 16
                          :width "100%"}}]
           (mapv (fn [idx]
                   [item-comparison-block {:index idx}])
                 (range 0 3)))
     (when items?
       (if (some #(some-> %
                          (second)
                          :data
                          (util/when-not-loading))
                 all-items)
         [alc/card {:title "Tag Distribution"
                    :icon-type :TagsIcon}
          (if items-data?
            (let [item->idx (->> all-items
                                 (mapv (fn [[idx {:keys [label]}]]
                                         [label idx]))
                                 (into {}))
                  all-items-data (some->> all-items
                                          (mapcat (fn [[_ {:keys [data]}]]
                                                    (util/when-not-loading data)))
                                          (filter identity))
                  tag-display-name->description (some->> all-items-data
                                                         (mapv (fn [i]
                                                                 (let [tag {:name (:tag-name i)
                                                                            :value (:tag-value i)}]
                                                                   [(tag/tag->display-name tag)
                                                                    (tag.d/tag->description tag)])))
                                                         (into {}))
                  tag-display-name->tag (some->> all-items-data
                                                 (mapv (fn [i]
                                                         (let [tag {:name (:tag-name i)
                                                                    :value (:tag-value i)}]
                                                           [(tag/tag->display-name tag) tag])))
                                                 (into {}))
                  chart-data (some->> all-items-data
                                      (group-by (fn [i]
                                                  {:name (:tag-name i)
                                                   :value (:tag-value i)}))
                                      (mapv (fn [[tag vals]]
                                              {:name (tag/tag->display-name tag)
                                               :values (->> vals
                                                            (mapv (fn [{:keys [item count]}]
                                                                    {:key item
                                                                     :value count}))
                                                            (vec))}))
                                      (sort-by :name)
                                      (vec))
                  chart-keys-config (->> all-items-data
                                         (mapv :item)
                                         (distinct)
                                         (mapv (fn [item]
                                                 {item {:fill (->> item
                                                                   (get item->idx)
                                                                   (get item-index->color))}}))
                                         (apply merge))]
              [recharts.c/bar-chart
               {:data chart-data
                :data-keys-config chart-keys-config
                :data-keys-sort-fn (fn [ks]
                                     (sort-by #(get item->idx %) ks))
                :bar-config {:on-double-click (fn [click-data _ e]
                                                (let [tag (-> click-data
                                                              :payload
                                                              :name
                                                              (tag-display-name->tag))
                                                      menu-item (some-> click-data
                                                                        :tooltipPayload
                                                                        (first)
                                                                        :name)]
                                                  (router/open-route-based-on-event
                                                    e
                                                    [:vi/sessions nil (assoc sessions-query-params
                                                                        :svm "utterances"
                                                                        :fd (sessions.d/filters->query-param
                                                                              [{:by "tags"
                                                                                :condition "include"
                                                                                :join "or"
                                                                                :value [tag]
                                                                                :children [{:by "menu-item"
                                                                                            :condition "include"
                                                                                            :join "or"
                                                                                            :value [menu-item]}]}]))])))}
                :chart-height 500
                :x-axis-config {:angle -45
                                :height 150
                                :description-fn (fn [{:keys [payload]}]
                                                  (tag-display-name->description (:value payload)))}
                :total-override convo-count
                :tooltip-config {:show-double-click-message? true}}])
            [empty-state/no-chart-data {}])]
         [empty-state/loading-comparisons-card]))
     (when (and items? items-data?)
       [alc/card {:title "Detailed Comparison"
                  :icon-type :TagsIcon}
        [:div
         [item-comparison-tabs]
         [crew-upsell-comparison]
         [customer-upsell-comparison]
         [user-questions-comparison]
         [unavailable-comparison]]])]))
